import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
@Injectable()
export class SatDescargaService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }

  post(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


  put(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  cargarDocumentos(sat_descarga_id: number, gral_usr_id: number): Observable<any> {
    let url_ = this.dataUrl + '/add-doc/cargar/documento/' + sat_descarga_id + '/' + gral_usr_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  get(id: number): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }


  getByEmpIdAndEstatus(id: number, estatus: String, p_folio: String, p_fechas: String, p_tipo: String): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/getByEmpIdAndEstatus/' + id + '/' + estatus + '/' + p_folio + '/' + p_fechas + '/' + p_tipo;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getByEmpCargadoId(id: number): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/getByEmpCargadoId/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  descargarDocumentos(idSatDescargaId: number,gral_usr_id: number): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/descargarDocumentos/' + idSatDescargaId + '/' + gral_usr_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  descargaHistorico(id: number) {
    let url_ = this.dataUrl + '/sat-descarga/descargaHistorica/zip/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  catalogo(filter: any): Observable<any> {
    let url_ = this.dataUrl + '/sat-descarga/catalogo';
    url_ = url_.replace(/[?&]$/, '');

    return this.http.post(url_, filter).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

}
